export default "__VITE_ASSET__CBsCYeGt__"